import { render } from "./PointsList.vue?vue&type=template&id=c62921ee"
import script from "./PointsList.vue?vue&type=script&lang=js"
export * from "./PointsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__